import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Flex, Pagination } from '~/components/blocks';
import { lineVisitorHistoryPageInfoState } from '~/state/reception/atoms';

export const HistoryPagination = () => {
  const theme = useTheme();

  const [pageInfo, setPageInfo] = useAtom(lineVisitorHistoryPageInfoState);
  const handleChangePage = useCallback(
    (page: number) => setPageInfo((_state) => ({ ..._state, page })),
    [setPageInfo],
  );

  return (
    <Flex justifyContent="center" marginTop={theme.space.l}>
      <Pagination
        currentPage={pageInfo.page}
        totalPage={pageInfo.totalPage}
        onChange={handleChangePage}
      />
    </Flex>
  );
};
